'use client'

import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { Typography } from 'components/Contentful'
import { Image } from 'components/Image'
import { SECTION_VARIANTS } from 'components/Section/Section'
import { useState } from 'react'
import { AchieveLink } from 'components/AchieveLink'
import { Button } from '@achieve/ascend'
import { ChevronLeft } from 'react-feather'
import { DebtSlider } from 'components/DebtSlider/DebtSlider'
import { AdvertisingDisclosures } from 'pageSections/HeroDebt/components/AdvertisingDisclosures'

const HeroDebtCard = ({ product, handleSelectedProduct }) => {
  return (
    <AchieveLink
      key={product?.sys?.id}
      noLink={product?.cardLink?.uiComponent === 'LinkToSection'}
      href={product?.cardLink?.uiComponent !== 'LinkToSection' ? product?.cardLink?.linkHref : null}
      onClick={() =>
        product?.cardLink?.uiComponent === 'LinkToSection' && handleSelectedProduct(product)
      }
    >
      <div className="px-2.5 py-4 border-2 border-solid border-gray-400 rounded-sm flex flex-col items-center bg-white cursor-pointer text-black hover:bg-gray-300 w-[175px] h-[105px] gap-2">
        <Image
          src={product?.cardImage?.url}
          alt={product?.cardImage?.alt || product?.name || ''}
          width={50}
          height={50}
        />
        <Typography content={product?.cardTitleText?.json} className="displayXs" />
      </div>
    </AchieveLink>
  )
}

export default function HeroDebt({ content }) {
  const { title, productsListTitle, productList, slider } = useMemoizedContentGetter(content, [
    'title',
    'productsListTitle',
    'productList',
    'slider',
  ])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [subProductList, setSubProductList] = useState({})

  const handleSelectedProduct = (product) => {
    setSelectedProduct(product?.cardLink?.linkText)
    setSubProductList(
      content?.fields?.sectionContents.find(
        (item) => item?.fields?.fieldName === product?.cardLink?.linkHref
      )?.fields ?? {}
    )
  }

  return (
    <Section
      childContainerClassName="flex flex-col items-center justify-center gap-6 py-20"
      variant={SECTION_VARIANTS.bgBlue25}
    >
      <div className="max-w-[750px] mx-auto flex flex-col items-center justify-center gap-6">
        <Typography content={title?.textContent} className="headingXl text-center" />
        {/* <div className="w-full h-[400px]" /> */}
        <div className="my-10">
          <DebtSlider
            mainImage={slider?.cardImage?.url}
            mainImageAlt={slider?.cardImage?.alt}
            badgeImage={slider?.cardBadgeImage?.url}
            badgeImageAlt={slider?.cardBadgeImage?.alt}
            title={slider?.cardTitleText}
            subtitle={slider?.cardSubtitleText}
            linkHref={slider?.cardJson?.slider?.linkHref}
            linkText={slider?.cardJson?.slider?.linkText}
            linkSubtext={slider?.cardText}
            sliderProps={slider?.cardJson?.slider}
          />
        </div>
      </div>
      {selectedProduct ? (
        <div className="flex flex-col items-center justify-center gap-6">
          <Typography content={selectedProduct} className="headingMd text-center" />
          <div className="flex flex-wrap items-center justify-center gap-4">
            {subProductList?.gridItemsCollection?.items?.map((product) => (
              <HeroDebtCard
                product={product}
                handleSelectedProduct={handleSelectedProduct}
                key={product?.sys?.id}
              />
            ))}
          </div>
          <AchieveLink
            content={subProductList?.ctaLink}
            className="text-center"
            noLink
            onClick={() => handleSelectedProduct(null)}
          >
            <Button className="text-center px-4" variant="text" color="primary">
              <ChevronLeft size={20} /> <Typography content="Back" className="text-center bodyMd" />
            </Button>
          </AchieveLink>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-6">
          <Typography content={productsListTitle?.textContent} className="headingMd text-center" />
          <div className="flex flex-wrap items-center justify-center gap-4">
            {productList?.gridItemsCollection?.items?.map((product) => (
              <HeroDebtCard
                product={product}
                handleSelectedProduct={handleSelectedProduct}
                key={product?.sys?.id}
              />
            ))}
          </div>
        </div>
      )}
      <div className="flex justify-end items-center w-full">
        <AdvertisingDisclosures />
      </div>
    </Section>
  )
}

export { HeroDebt }
